import { ChangeEvent, FormEvent, useEffect, useState } from 'react'
import '../index.css';
import cup from '../assets/cup.png'
import { config } from '../config';
import { Loader } from './Loader';


interface propTypes {
  isArabic: boolean;
  id: string;
  ref: any;
  sectionTranslations: Record<string, string>;
}


type LocalizedCity = {
  en: string;
  ar: string;
};

type CountryCityMap = Record<string, { en: string; ar: string; cities: LocalizedCity[] }>;

export const countryCityMap: CountryCityMap = {
  qa: {
    en: 'Qatar',
    ar: 'قطر',
    cities: [
      { en: 'Doha', ar: 'الدوحة' },
      { en: 'Al Wakrah', ar: 'الوكرة' },
      { en: 'Al Rayyan', ar: 'الريان' },
      { en: 'Lusail', ar: 'لوسيل' },
      { en: 'Al Khor', ar: 'الخور' },
      { en: 'Umm Salal', ar: 'أم صلال' },
      { en: 'Dukhan', ar: 'دخان' },
      { en: 'Mesaieed', ar: 'مسيعيد' },
      { en: 'Other', ar: 'أخرى' },
    ],
  },
  ae: {
    en: 'UAE',
    ar: 'الإمارات',
    cities: [
      { en: 'Dubai', ar: 'دبي' },
      { en: 'Abu Dhabi', ar: 'أبو ظبي' },
      { en: 'Sharjah', ar: 'الشارقة' },
      { en: 'Ajman', ar: 'عجمان' },
      { en: 'Ras Al Khaimah', ar: 'رأس الخيمة' },
      { en: 'Fujairah', ar: 'الفجيرة' },
      { en: 'Umm Al Quwain', ar: 'أم القيوين' },
      { en: 'Al Ain', ar: 'العين' },
      { en: 'Other', ar: 'أخرى' },
    ],
  },
  om: {
    en: 'Oman',
    ar: 'عُمان',
    cities: [
      { en: 'Muscat', ar: 'مسقط' },
      { en: 'Salalah', ar: 'صلالة' },
      { en: 'Sohar', ar: 'صحار' },
      { en: 'Nizwa', ar: 'نزوى' },
      { en: 'Sur', ar: 'صور' },
      { en: 'Ibri', ar: 'عبري' },
      { en: 'Barka', ar: 'بركاء' },
      { en: 'Al Buraimi', ar: 'البريمي' },
      { en: 'Adam', ar: 'أدم' },
      { en: 'Al Awabi', ar: 'العوابي' },
      { en: 'Al Hamra', ar: 'الحمراء' },
      { en: 'Bahla', ar: 'بهلاء' },
      { en: 'Bidbid', ar: 'بدبد' },
      { en: 'Dalkut', ar: 'ضلكوت' },
      { en: 'Dhank', ar: 'ضنك' },
      { en: 'Dima Wa Al Tayyin', ar: 'دماء والطائيين' },
      { en: 'Duqm', ar: 'الدقم' },
      { en: 'Haima', ar: 'هيماء' },
      { en: 'Ibra', ar: 'إبراء' },
      { en: 'Izki', ar: 'إزكي' },
      { en: 'Jalan Bani Bu Ali', ar: 'جعلان بني بو علي' },
      { en: 'Jalan Bani Bu Hassan', ar: 'جعلان بني بو حسن' },
      { en: 'Khasab', ar: 'خصب' },
      { en: 'Liwa', ar: 'لوى' },
      { en: 'Madha', ar: 'مدحاء' },
      { en: 'Mahout', ar: 'محوت' },
      { en: 'Manah', ar: 'منح' },
      { en: 'Masirah', ar: 'مصيرة' },
      { en: 'Mirbat', ar: 'مرباط' },
      { en: 'Mudhaibi', ar: 'المضيبي' },
      { en: 'Muttrah', ar: 'مطرح' },
      { en: 'Nakhal', ar: 'نخل' },
      { en: 'Quriyat', ar: 'قريات' },
      { en: 'Rakhyut', ar: 'رخيوت' },
      { en: 'Rustaq', ar: 'الرستاق' },
      { en: 'Saham', ar: 'صحم' },
      { en: 'Samail', ar: 'سمائل' },
      { en: 'Seeb', ar: 'السيب' },
      { en: 'Shalim', ar: 'شليم' },
      { en: 'Shinas', ar: 'شناص' },
      { en: 'Sinaw', ar: 'سناو' },
      { en: 'Taqah', ar: 'طاقة' },
      { en: 'Thumrait', ar: 'ثمريت' },
      { en: 'Wadi Al Maawil', ar: 'وادي المعاول' },
      { en: 'Yanqul', ar: 'ينقل' },
      { en: 'Other', ar: 'أخرى' },
    ],
  },
  sa: {
    en: 'Saudi Arabia',
    ar: 'السعودية',
    cities: [
      { en: 'Riyadh', ar: 'الرياض' },
      { en: 'Jeddah', ar: 'جدة' },
      { en: 'Dammam', ar: 'الدمام' },
      { en: 'Khobar', ar: 'الخبر' },
      { en: 'Mecca', ar: 'مكة' },
      { en: 'Medina', ar: 'المدينة المنورة' },
      { en: 'Abha', ar: 'أبها' },
      { en: 'Tabuk', ar: 'تبوك' },
      { en: 'Hail', ar: 'حائل' },
      { en: 'Other', ar: 'أخرى' },
    ],
  },
  ku: {
    en: 'Kuwait',
    ar: 'الكويت',
    cities: [
      { en: 'Kuwait City', ar: 'مدينة الكويت' },
      { en: 'Hawalli', ar: 'حولي' },
      { en: 'Salmiya', ar: 'السالمية' },
      { en: 'Farwaniya', ar: 'الفروانية' },
      { en: 'Ahmadi', ar: 'الأحمدي' },
      { en: 'Jahra', ar: 'الجهراء' },
      { en: 'Fahaheel', ar: 'الفحيحيل' },
      { en: 'Mangaf', ar: 'المنقف' },
      { en: 'Sabah Al Salem', ar: 'صباح السالم' },
      { en: 'Salwa', ar: 'سلوى' },
      { en: 'Other', ar: 'أخرى' },
    ],
  },
  bh: {
    en: 'Bahrain',
    ar: 'البحرين',
    cities: [
      { en: 'Manama', ar: 'المنامة' },
      { en: 'Muharraq', ar: 'المحرق' },
      { en: 'Riffa', ar: 'الرفاع' },
      { en: 'Isa Town', ar: 'مدينة عيسى' },
      { en: 'Sitra', ar: 'سترة' },
      { en: 'Budaiya', ar: 'البديع' },
      { en: 'Jidhafs', ar: 'جدحفص' },
      { en: 'Hamad Town', ar: 'مدينة حمد' },
      { en: 'Aali', ar: 'عالي' },
      { en: 'Other', ar: 'أخرى' },
    ],
  },
  other: {
    en: 'Other',
    ar: 'أخرى',
    cities: [
      { en: 'Other', ar: 'أخرى' },
    ],
  },
};



const phoneFormats: Record<string, { format: string }> = {
  '+971': { format: '^0?5\\d{8}$' },              // UAE
  '+966': { format: '^0?5\\d{8}$' },              // Saudi Arabia
  '+974': { format: '^0?(?:33|44|5[0-9]|66|77|92|94|95)\\d{6}$' }, // Qatar
  '+968': { format: '^[279]\\d{7}$' },            // Oman
  '+973': { format: '^0?1\\d{8}$' },              // Bahrain
  '+965': { format: '^[569]\\d{7}$' },            // Kuwait
  '+44': { format: '^0?1\\d{8}$' },              // UK
  '+1': { format: '^[0-9]{3}-[0-9]{3}-[0-9]{4}$' }, // USA
};

const dialCodes = Object.keys(phoneFormats); // ['+971', '+966', ...]


export default function PartnerForm({ isArabic, ref, sectionTranslations }: propTypes) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1190);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const defaultState = {
    shopName: '',
    contactName: '',
    email: '',
    phone: '',
    code: '+971',
    country: '',
    instagram: '',
    city: ''
  };

  const [{ shopName, contactName, email, phone, code, country, city, instagram }, setData] = useState(defaultState);


  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, validator?: Function) => {
    const { name, value } = e.target;

    if (validator && !validator(value)) return;

    setData(prevState => {
      if (name === 'country') {
        return {
          ...prevState,
          [name]: value,
          city: ''
        };
      }

      return {
        ...prevState,
        [name]: value
      };
    });
  };
  const phoneValidator = (value: string) => {
    const partialPhoneRegex = /^\+?\d{0,4}[-.\s]?\(?(\d{0,3})\)?[-.\s]?(\d{0,4})[-.\s]?(\d{0,4})[-.\s]?(\d{0,9})$/;
    return partialPhoneRegex.test(value);
  };
  const phoneFinalValidator = (code: string, value: string): boolean => {
    const format = phoneFormats[code]?.format;
    if (!format) return true;

    const regex = new RegExp(format);
    return regex.test(value);
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    setError('');
    setMessage('');

    console.log(!phoneFinalValidator(code, phone))
    if (!phoneFinalValidator(code, phone)) {
      setError(isArabic ? 'رقم الهاتف غير صالح' : 'Phone number validation failed');
      return;
    }

    const payload = {
      contact: {
        name: contactName,
        email,
        phone: code + phone,
        instagram,
      },
      shop: {
        name: shopName,
        country,
        city,
      },
    };

    setLoading(true);

    try {
      const response = await fetch(`${config.baseUrl}/api/partners`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      setMessage(isArabic ? 'تم استلام طلبك بنجاح' : 'Your request has been sent successfully');
      setData(defaultState);
    } catch (err) {
      console.error(err);
      setError(isArabic ? 'حدث خطأ أثناء إرسال الطلب' : 'Failed to send the request');
    } finally {
      setTimeout(() => {
        setMessage('');
      }, 2000);
      setLoading(false);
    }
  };


  const loginRedirect = () => {
    window.location.assign(`${config.baseUrl}/portal/login`);
  }

  return (
    <div className={`py-10 backcolor  scroll-margin-top ${isArabic ? 'flex-row-reverse pr-10' : 'pl-10'}`} ref={ref} id={sectionTranslations.partner}
      style={{
        paddingRight: isArabic ? (isMobile ? '' : '') : isMobile ? '0' : '2.5rem',
        paddingLeft: isArabic ? (isMobile ? '0' : '2.5rem') : isMobile ? '2.5rem' : '2.5rem',
      }}>
      <div className={`partner-section ${isArabic ? 'flex-row-reverse' : 'flex-row'}`}
        style={{
          marginLeft: isArabic ? (isMobile ? '' : '') : isMobile ? '-2.5rem' : '2.5rem',
          marginRight: isArabic ? (isMobile ? '-2.5rem' : '2.5rem') : isMobile ? '' : '',
        }}>
        <div className="partner-form">
          <div className="partner-text">
            <h2 className='text-[#D7D7D9] '
              style={{
                fontFamily: isArabic ? (isMobile ? 'ArabicFontSemi' : 'ArabicFontBold') : isMobile ? 'EngBold' : 'EngBold',
                fontSize: isArabic ? (isMobile ? '28px' : '45px') : isMobile ? '28px' : '45px',
                textAlign: isArabic ? 'right' : 'left',
                paddingBottom: isMobile ? '0rem' : '',
              }}>
              {isArabic ? 'انضم كشريك' : 'BECOME A PARTNER'}
            </h2>
            <p className='text-[#C7E9F5]'
              style={{
                fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontMedium') : isMobile ? 'EngMedium' : 'EngMedium',
                textAlign: isArabic ? 'right' : 'left',
                fontSize: isArabic ? (isMobile ? '24px' : '40px') : isMobile ? '24px' : '40px',
              }}>
              {isArabic ? 'اشترك الان' : 'Join us now'}
            </p>
          </div>
          <form onSubmit={handleSubmit} >
            <div>
              <p className='text-[#D7D7D9] mb-8'
                style={{
                  fontSize: isArabic ? (isMobile ? '15px' : '20px') : isMobile ? '15px' : '20px',
                  fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontMedium') : isMobile ? 'EngMedium' : 'EngMedium',
                  lineHeight: '2rem',
                  textAlign: isArabic ? 'right' : 'left',
                  marginBottom: isArabic ? (isMobile ? '1rem' : '') : isMobile ? '1rem' : '',
                }}>
                {isArabic ? 'يرجى ملء النموذج التالي وسوف نتصل بك في غضون 24 ساعة' : 'Please fill in the following form and we will contact you within 24 hours:'}
              </p>
            </div>
            <div className="input-row">
              {isArabic ? (
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="phone"
                      style={{
                        fontFamily: isArabic ? 'ArabicFontRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'رقم الجوال' : 'Phone*'}
                    </label>

                    <div style={{ display: 'flex', gap: '0.5rem', flexDirection: isArabic ? 'row-reverse' : 'row' }}>
                      <select
                        name="code"
                        value={code}
                        onChange={handleChange}
                        className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`}
                        required
                        style={{ width: '30%', direction: 'ltr' }}
                      >
                        <option value="" disabled hidden>
                          {isArabic ? 'رمز الدولة' : 'Code'}
                        </option>
                        {dialCodes.map((code) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>

                      <input
                        type="text"
                        name="phone"
                        value={phone}
                        onChange={(e) => handleChange(e, phoneValidator)}
                        placeholder={isArabic ? 'ادخل رقم الجوال' : '#phone'}
                        className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`}
                        style={{ flex: 1 }}
                        required
                      />
                    </div>
                  </div>

                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="shopName"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'اسم محل القهوة' : 'Coffee shop name*'}
                    </label>
                    <input type="text" name="shopName" value={shopName} id="shopName" onChange={handleChange} maxLength={240} placeholder={isArabic ? 'اسم محل القهوة' : '#cafename'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                  </div>
                </>
              ) : (
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="shopName"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'اسم محل القهوة' : 'Coffee shop name*'}
                    </label>
                    <input type="text" id="shopName" name="shopName" value={shopName} onChange={handleChange} maxLength={240} placeholder={isArabic ? 'اسم محل القهوة' : '#cafename'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                  </div>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="phone"
                      style={{
                        fontFamily: isArabic ? 'ArabicFontRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'رقم الجوال' : 'Phone*'}
                    </label>

                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <select
                        name="code"
                        value={code}
                        onChange={handleChange}
                        className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`}
                        required
                        style={{ width: '30%', direction: 'ltr' }}
                      >
                        <option value="" disabled hidden>
                          {isArabic ? 'رمز الدولة' : 'Code'}
                        </option>
                        {dialCodes.map((code) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>

                      <input
                        type="text"
                        name="phone"
                        value={phone}
                        onChange={(e) => handleChange(e, phoneValidator)}
                        placeholder={isArabic ? 'ادخل رقم الجوال' : '#phone'}
                        className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`}
                        style={{ flex: 1 }}
                        required
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="input-row">
              {isArabic ? (
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="country">
                      {isArabic ? 'المنطقة' : 'Country*'}
                    </label>
                    <select
                      name="country"
                      id="country"
                      value={country}
                      onChange={handleChange}
                      className={isArabic ? 'styled-input-arabic' : 'styled-input'}
                      style={{ color: country === '' ? '#D7D7D9' : '#000000' }}
                      required
                    >
                      <option value="" disabled>
                        {isArabic ? 'اختر الدولة' : 'Select Country'}
                      </option>
                      {Object.entries(countryCityMap).map(([key, value]) => (
                        <option key={key} value={key}>
                          {isArabic ? value.ar : value.en}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="contactName"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'اسم التواصل' : 'Contact name*'}
                    </label>
                    <input name='contactName' value={contactName} onChange={handleChange} type="text" id="contactName" placeholder={isArabic ? 'ادخل اسمك' : '#contactName'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                  </div>
                </>
              ) : (
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="contactName"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'اسم التواصل' : 'Contact name*'}
                    </label>
                    <input type="text" name='contactName' value={contactName} onChange={handleChange} id="contactName" placeholder={isArabic ? 'ادخل اسمك' : '#contactName'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                  </div>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="country">
                      {isArabic ? 'المنطقة' : 'Country*'}
                    </label>
                    <select
                      name="country"
                      id="country"
                      value={country}
                      onChange={handleChange}
                      className={isArabic ? 'styled-input-arabic' : 'styled-input'}
                      required
                      style={{ color: country === '' ? '#D7D7D9' : '#000000' }}
                    >
                      <option value="" disabled>
                        {isArabic ? 'اختر الدولة' : 'Select Country'}
                      </option>
                      {Object.entries(countryCityMap).map(([key, value]) => (
                        <option key={key} value={key}>
                          {isArabic ? value.ar : value.en}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
            <div className="input-row">
              {isArabic ? (isMobile ?
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="city"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'المدينة' : 'City*'}
                    </label>
                    {country === 'other' ? (
                      <input type="text" id="city" name='city' value={city} onChange={handleChange} placeholder={isArabic ? 'ادخل اسم المدينة' : '#city'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                    ) : (
                      <select
                        name="city"
                        id="city"
                        value={city}
                        onChange={handleChange}
                        className={isArabic ? 'styled-input-arabic' : 'styled-input'}
                        required
                        disabled={!country}
                        style={{ color: city === '' ? '#D7D7D9' : '#000000' }}
                      >
                        <option value="" disabled>
                          {isArabic ? 'اختر المدينة' : 'Select City'}
                        </option>
                        {(countryCityMap[country]?.cities || []).map((city) => (
                          <option key={city.en} value={city.en}>
                            {isArabic ? city.ar : city.en}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="email"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'البريد الالكتروني(اختياري)' : 'Email Address(optional)'}
                    </label>
                    <input type="email" name='email' value={email} id="email" onChange={handleChange} placeholder={isArabic ? 'ادخل بريدك الالكتروني' : '@gmail.com'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} />
                  </div>
                </>
                :
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="city">
                      {isArabic ? 'المدينة' : 'City*'}
                    </label>
                    {country === 'other' ? (
                      <input type="text" id="city" name='city' value={city} onChange={handleChange} placeholder={isArabic ? 'ادخل اسم المدينة' : '#city'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                    ) : (
                      <select
                        name="city"
                        id="city"
                        value={city}
                        onChange={handleChange}
                        className={isArabic ? 'styled-input-arabic' : 'styled-input'}
                        required
                        disabled={!country}
                        style={{ color: city === '' ? '#D7D7D9' : '#000000' }}
                      >
                        <option value="" disabled>
                          {isArabic ? 'اختر المدينة' : 'Select City'}
                        </option>
                        {(countryCityMap[country]?.cities || []).map((city) => (
                          <option key={city.en} value={city.en}>
                            {isArabic ? city.ar : city.en}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="email"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'البريد الالكتروني(اختياري)' : 'Email Address(optional)'}
                    </label>
                    <input type="email" id="email" name='email' value={email} onChange={handleChange} placeholder={isArabic ? 'ادخل بريدك الالكتروني' : '@gmail.com'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} />
                  </div>
                </>
              ) : isMobile ? (
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="email"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'البريد الالكتروني(اختياري)' : 'Email Address(optional)'}
                    </label>
                    <input type="email" id="email" name="email" value={email} onChange={handleChange} placeholder={isArabic ? 'ادخل بريدك الالكتروني' : '@gmail.com'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} />
                  </div>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="city">
                      {isArabic ? 'المدينة' : 'City*'}
                    </label>
                    {country === 'other' ? (
                      <input type="text" id="city" name='city' value={city} onChange={handleChange} placeholder={isArabic ? 'ادخل اسم المدينة' : '#city'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                    ) : (
                      <select
                        name="city"
                        id="city"
                        value={city}
                        onChange={handleChange}
                        className={isArabic ? 'styled-input-arabic' : 'styled-input'}
                        required
                        disabled={!country}
                        style={{ color: city === '' ? '#D7D7D9' : '#000000' }}
                      >
                        <option value="" disabled>
                          {isArabic ? 'اختر المدينة' : 'Select City'}
                        </option>
                        {(countryCityMap[country]?.cities || []).map((city) => (
                          <option key={city.en} value={city.en}>
                            {isArabic ? city.ar : city.en}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </>
              ) :
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="email"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'البريد الالكتروني(اختياري)' : 'Email Address(optional)'}
                    </label>
                    <input type="email" id="email" name="email" value={email} onChange={handleChange} placeholder={isArabic ? 'ادخل بريدك الالكتروني' : '@gmail.com'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} />
                  </div>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="city">
                      {isArabic ? 'المدينة' : 'City*'}
                    </label>
                    {country === 'other' ? (
                      <input type="text" id="city" name='city' value={city} onChange={handleChange} placeholder={isArabic ? 'ادخل اسم المدينة' : '#city'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                    ) : (
                      <select
                        name="city"
                        id="city"
                        value={city}
                        onChange={handleChange}
                        className={isArabic ? 'styled-input-arabic' : 'styled-input'}
                        required
                        disabled={!country}
                        style={{ color: city === '' ? '#D7D7D9' : '#000000' }}
                      >
                        <option value="" disabled>
                          {isArabic ? 'اختر المدينة' : 'Select City'}
                        </option>
                        {(countryCityMap[country]?.cities || []).map((city) => (
                          <option key={city.en} value={city.en}>
                            {isArabic ? city.ar : city.en}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </>
              }
            </div>
            <div className="input-row">
              {isArabic ? (isMobile ?
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? ' حساب الانستغرام (اختياري)' : 'Instagram Account(optional)'}
                    </label>
                    <input type="instagram" name='instagram' value={instagram} id="instagram" onChange={handleChange} placeholder={isArabic ? '@معرف الانستاغرام' : '@yurInstagram'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} />
                    <div className={`${isArabic ? 'partner-button-container-arabic' : 'partner-button-container'}`}
                      style={{ marginTop: '10%' }}>
                      {error ? <span className='error-msg'>{error}</span> :
                        loading ? <Loader size={40} /> :
                          message ? <span className='success-msg'>{message}</span> :
                            null
                      }

                      {message ? null :
                        <button type="submit" className="partner-styled-button"
                          disabled={loading}
                          style={{
                            fontFamily: isArabic ? (isMobile ? 'ArabicFontBold' : 'ArabicFontBold') : isMobile ? 'EngBold' : 'EngBold',
                          }}>
                          {isArabic ? 'ارسال' : 'Submit'}
                        </button>}
                      <p className={`${isArabic ? 'centered-text-arabic' : 'centered-text'} text-[#788E9F] capitalize`}
                        style={{
                          fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                          lineHeight: isArabic ? (isMobile ? '1rem' : '2rem') : isMobile ? '1rem' : '2rem',
                          marginTop: isArabic ? (isMobile ? '0.5rem' : '0.5rem') : isMobile ? '0.5rem' : '0.5rem',
                          marginRight: isArabic ? (isMobile ? '0rem' : '0rem') : isMobile ? '0rem' : '3rem',
                        }}>
                        {isArabic ?
                          <>
                            شريك سابق؟ <a className="text-[#C7E9F5] cursor-pointer" onClick={loginRedirect}>سجل الدخول</a>
                          </> :
                          <>
                            I’m already A partner?&nbsp; <a className='text-[#C7E9F5] cursor-pointer' onClick={loginRedirect}> Login</a>
                          </>
                        }
                      </p>
                    </div>
                  </div>
                </>
                :
                <>
                  <div style={{ visibility: 'hidden' }} className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="city"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'المدينة' : 'City*'}
                    </label>
                    <input type="text" id="city" name="city" value={city} onChange={handleChange} placeholder={isArabic ? 'ادخل اسم المدينة' : '#city'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                  </div>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? ' حساب الانستغرام (اختياري)' : 'Instagram Account(optional)'}
                    </label>
                    <input type="instagram" id="instagram" name="instagram" value={instagram} onChange={handleChange} placeholder={isArabic ? '@معرف الانستاغرام' : '@yourInstagram'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} />
                    <div className={`${isArabic ? 'partner-button-container-arabic' : 'partner-button-container'}`}
                      style={{ marginTop: '10%' }}>
                      {error ? <span className='error-msg'>{error}</span> :
                        loading ? <Loader size={40} /> :
                          message ? <span className='success-msg'>{message}</span> :
                            null
                      }
                      {message ? null :
                        <button type="submit" className="partner-styled-button"
                          disabled={loading}
                          style={{
                            fontFamily: isArabic ? (isMobile ? 'ArabicFontBold' : 'ArabicFontBold') : isMobile ? 'EngBold' : 'EngBold',
                          }}>
                          {isArabic ? 'ارسال' : 'Submit'}
                        </button>}
                      <p className={`${isArabic ? 'centered-text-arabic' : 'centered-text'} text-[#788E9F] capitalize`}
                        style={{
                          fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                          lineHeight: isArabic ? (isMobile ? '1rem' : '2rem') : isMobile ? '1rem' : '2rem',
                          marginTop: isArabic ? (isMobile ? '0.5rem' : '0.5rem') : isMobile ? '0.5rem' : '0.5rem',
                          marginRight: isArabic ? (isMobile ? '0rem' : '') : isMobile ? '0rem' : '3rem',
                          margin: isArabic ? 'auto' : '',
                        }}>
                        {isArabic ?
                          <>
                            شريك سابق؟ <a className="text-[#C7E9F5] cursor-pointer" onClick={loginRedirect}>سجل الدخول</a>
                          </> :
                          <>
                            I’m already A partner?&nbsp; <a className='text-[#C7E9F5] cursor-pointer' onClick={loginRedirect}> Login</a>
                          </>
                        }
                      </p>
                    </div>
                  </div>
                </>
              ) : isMobile ? (
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? ' حساب الانستغرام (اختياري)' : 'Instagram Account(optional)'}
                    </label>
                    <input type="instagram" id="instagram" name="instagram" value={instagram} onChange={handleChange} placeholder={isArabic ? '@معرف الانستاغرام' : '@yourInstagram'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} />
                  </div>
                  <div className={`${isArabic ? 'partner-button-container-arabic' : 'partner-button-container'}`}
                    style={{ marginTop: '10%' }}>
                    {error ? <span className='error-msg'>{error}</span> :
                      loading ? <Loader size={40} /> :
                        message ? <span className='success-msg'>{message}</span> :
                          null
                    }
                    {message ? null :
                      <button type="submit" className="partner-styled-button"
                        style={{
                          fontFamily: isArabic ? (isMobile ? 'ArabicFontBold' : 'ArabicFontBold') : isMobile ? 'EngBold' : 'EngBold',
                        }}
                        disabled={loading}>
                        {isArabic ? 'ارسال' : 'Submit'}
                      </button>}
                    <p className={`${isArabic ? 'centered-text-arabic' : 'centered-text'} text-[#788E9F] capitalize`}
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                        lineHeight: isArabic ? (isMobile ? '1rem' : '2rem') : isMobile ? '1rem' : '2rem',
                        marginTop: isArabic ? (isMobile ? '0.5rem' : '0.5rem') : isMobile ? '0.5rem' : '0.5rem',
                        marginRight: isArabic ? (isMobile ? '0rem' : '4rem') : isMobile ? '0rem' : '3rem',
                      }}>
                      {isArabic ?
                        <>
                          شريك سابق؟ <a className="text-[#C7E9F5] cursor-pointer" onClick={loginRedirect}>سجل الدخول</a>
                        </> :
                        <>
                          I’m already A partner?&nbsp; <a className='text-[#C7E9F5] cursor-pointer' onClick={loginRedirect}> Login</a>
                        </>
                      }
                    </p>
                  </div>
                </>
              ) :
                <>
                  <div className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? ' حساب الانستغرام (اختياري)' : 'Instagram Account(optional)'}
                    </label>
                    <input type="instagram" id="instagram" name="instagram" value={instagram} onChange={handleChange} placeholder={isArabic ? '@معرف الانستاغرام' : '@yourInstagram'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} />
                    <div className={`${isArabic ? 'partner-button-container-arabic' : 'partner-button-container'}`}
                      style={{ display: 'flex', flexDirection: 'column', marginTop: '10%' }}>
                      {error ? <span className='error-msg'>{error}</span> :
                        loading ? <Loader size={40} /> :
                          message ? <span className='success-msg'>{message}</span> :
                            null
                      }
                      {message ? null :
                        <button type="submit" className="partner-styled-button"
                          style={{
                            fontFamily: isArabic ? (isMobile ? 'ArabicFontBold' : 'ArabicFontBold') : isMobile ? 'EngBold' : 'EngBold',
                          }}
                          disabled={loading}>
                          {isArabic ? 'ارسال' : 'Submit'}
                        </button>}
                      <div className="centered-paragraph-container">
                        <p className={`${isArabic ? 'centered-text-arabic' : 'centered-text'} text-[#788E9F] capitalize`}
                          style={{
                            fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                            lineHeight: isArabic ? (isMobile ? '1rem' : '2rem') : isMobile ? '1rem' : '2rem',
                            marginTop: isArabic ? (isMobile ? '0.5rem' : '0.5rem') : isMobile ? '0.5rem' : '0.5rem',
                            margin: 'auto',
                          }}>
                          {isArabic ?
                            <>
                              شريك سابق؟ <a className="text-[#C7E9F5] cursor-pointer" onClick={loginRedirect}>سجل الدخول</a>
                            </> :
                            <>
                              I’m already A partner?&nbsp; <a className='text-[#C7E9F5] cursor-pointer' onClick={loginRedirect}> Login</a>
                            </>
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                  <div style={{ visibility: 'hidden' }} className={`${isArabic ? 'input-group-arabic' : 'input-group'}`}>
                    <label htmlFor="city"
                      style={{
                        fontFamily: isArabic ? (isMobile ? 'ArabicFontRegular' : 'ArabicFontRegular') : isMobile ? 'EngRegular' : 'EngRegular',
                      }}>
                      {isArabic ? 'المدينة' : 'City*'}
                    </label>
                    <input type="text" id="city" name="city" value={city} onChange={handleChange} placeholder={isArabic ? 'ادخل اسم المدينة' : '#city'} className={`${isArabic ? 'styled-input-arabic' : 'styled-input'}`} required />
                  </div>
                </>
              }
            </div>
          </form>
        </div>
        <div className="partner-image"
          style={{
            paddingTop: isArabic ? (isMobile ? '0' : '2.6rem') : isMobile ? '0' : '2.6rem',
          }}>
          <img src={cup} alt="Partner Image" />
          <p className='text-[#D7D7D9]'
            style={{
              fontSize: isArabic ? (isMobile ? '' : '20px') : isMobile ? '' : '20px',
              fontFamily: isArabic ? (isMobile ? 'ArabicFontLight' : 'ArabicFontLight') : isMobile ? 'EngRegular' : 'EngRegular',
              lineHeight: isMobile ? '1.5rem' : '2rem',
            }}>
            {isArabic ? (isMobile ? (
              <>
                إذا كان لديك أي أسئلة او استفسار حول أن تصبح شريك <br />
                <span
                  className="text-[#5D8FB7]"
                  style={{
                    fontFamily: isMobile ? 'ArabicFontMedium' : 'ArabicFontMedium',
                  }}
                >
                  sales@beanz.ae
                </span>
                {' '}   يرجى مراسلتنا على{' '}
              </>
            ) : <>
              إذا كان لديك أي أسئلة او استفسار حول أن تصبح شريك <br />
              <span
                className="text-[#5D8FB7]"
                style={{
                  fontFamily: isMobile ? 'ArabicFontMedium' : 'ArabicFontMedium',
                }}
              >
                sales@beanz.ae
              </span>
              {' '}   يرجى مراسلتنا على{' '}
            </>
            ) : (
              isMobile ? (
                <>
                  If you have any questions about becoming a partner,<br /> please email us at <span className='text-[#5D8FB7]'
                    style={{
                      fontFamily: isArabic ? (isMobile ? 'ArabicFontSemi' : 'ArabicFontBold') : isMobile ? 'EngSemi' : 'EngSemi',
                    }}>sales@beanz.ae</span>.
                </>
              ) : <>
                If you have any questions about becoming <br /> a partner, please email us at <span className='text-[#5D8FB7]'
                  style={{
                    fontFamily: isArabic ? (isMobile ? 'ArabicFontSemi' : 'ArabicFontBold') : isMobile ? 'EngSemi' : 'EngSemi',
                  }}>sales@beanz.ae</span>.
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}
